import NewPerson from './NewPerson';

export default NewPerson;
